import React from "react";
import submit from "submit-form";
import DropdownIcons from "../../../../parts/inputs/dropdown-icons";
import SvgIcon from "../../../../parts/SvgIcon";
const SORT_ITEMS = [
  {
    title: "A-Z",
    src: "/img/svg/sort-amount-up.svg",
    alt: "asc",
    className: "grey",
    id: "asc",
  },
  {
    title: "Z-A",
    src: "/img/svg/sort-amount-down.svg",
    alt: "desc",
    className: "grey",
    id: "desc",
  },
  {
    title: "Custom",
    src: "/img/svg/sort-amount-down.svg",
    alt: "custom",
    className: "grey",
    id: "custom",
  },
];
const ProgramCategory = ({
  category,
  showMostPopular,
  selectedCategoryIndex,
  selectCategory,
  programCategoriesLength,
  idx,
}) => (
  <button
    data-button-type={
      selectedCategoryIndex === idx && !showMostPopular
        ? "outline"
        : "secondary"
    }
    className="cat-tag"
    key={idx}
    onClick={() => selectCategory(idx, category)}
  >
    {category ? (
      <span>{category}</span>
    ) : (
      <>
        <input
          type="text"
          placeholder="Write a Category Name"
          className="trik"
        />
        <span
          className="trik"
          style={{
            color: "var(--green)",
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          +
        </span>
      </>
    )}
  </button>
);

const SubHeader = ({
  storePrograms,
  programCategories = [],
  lastPushed,
  showSortableMenu,
  handleSort,
  openCustomSort,
  toggleMostPopular,
  toggleSortable,
  addCategory,
  showMostPopular,
  selectedCategoryIndex,
  selectCategory,
}) => {
  const goToAllPrograms = () => {
    if (showMostPopular) {
      toggleMostPopular();
    }

    submit("/actions/refresh?", {
      method: "GET",
      body: {
        selectedCategoryIndex: "all",
      },
    });
  };

  const programCategoriesModified = [...programCategories, "Uncategorized"];
  const handleDropdownSort = (option) => {
    if (option === "asc") return handleSort();
    if (option === "desc") return handleSort("down");
    return openCustomSort();
  };
  return (
    <hgroup className="header-categories">
      <button
        onClick={() => {
          goToAllPrograms();
        }}
        data-button-type={
          !showMostPopular &&
          (selectedCategoryIndex === "all" ||
            (!selectedCategoryIndex &&
              typeof selectedCategoryIndex !== "number"))
            ? "outline"
            : "secondary"
        }
      >
        <span>All</span>
      </button>
      {programCategoriesModified &&
        programCategoriesModified.map((category, idx) => (
          <ProgramCategory
            key={`${category}-${idx}`}
            idx={idx}
            category={category}
            showMostPopular={showMostPopular}
            selectedCategoryIndex={selectedCategoryIndex}
            selectCategory={selectCategory}
            programCategoriesLength={programCategoriesModified.length}
          />
        ))}

      <button
        data-button-type={showMostPopular ? "outline" : "secondary"}
        onClick={() => toggleMostPopular()}
        className="gap-2"
      >
        <img alt="star" src="/img/new-icons/golden-star.svg" />
        <span>Most Popular</span>
      </button>
      <button
        data-button-type="secondary"
        data-icon
        onClick={() => addCategory()}
      >
        <SvgIcon alt="add" src="/img/new-icons/add.svg" /> Add Category
      </button>
    </hgroup>
  );
};

export default SubHeader;
